/* CleanRide: selector de modelo (CLAUDE.md §5.1). Markup en snippets/cr-model-picker.liquid.
   Falla abierto (§2.9): si el catálogo no carga, se escribe el coche a mano y se compra igual. */
(function () {
  if (customElements.get('cr-model-picker')) return;

  var MAX_RESULTADOS = 8;
  var TIMEOUT_CARGA = 8000;
  var NO_SE = 'No estoy seguro: me contactáis para pedirme una foto';
  var ENTENDIDO = 'Entendido: os envío la foto por WhatsApp';
  // Cliente que no sabe la respuesta: lo que ve él (property visible, sale en el pago) y el aviso
  // oculto para Albert en el admin (_Verificación).
  var PENDIENTE = 'Te escribiremos por WhatsApp para pedirte una foto';
  var PENDIENTE_ADMIN = 'PENDIENTE, pedir foto al cliente';

  // Enlace compartible de la ficha: ?modelo=…&alfombrilla=…&borde=…&talonera=…&respuesta=…
  // (el pack va en ?variant=, que ya gestiona Shopify). El color por defecto de cada grupo no se escribe.
  // data-color: nombre de la opción «Igual que la alfombrilla», cuyo value lleva además el color real.
  var PARAM_COLOR = { alfombrilla: 'Color alfombrilla', borde: 'Color borde', talonera: 'Color talonera' };
  var RESPUESTA_FOTO = 'foto';
  function slugURL(t) {
    return String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function radiosColor(prop) {
    return Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][name="properties[' + prop + ']"]'));
  }
  var ALIAS = { volkswagen: 'vw', 'mercedes-benz': 'mercedes', citroen: 'citroën' };
  // Los nombres de la web van en español (nombre_web); se buscan también por cómo los escribe la gente.
  var SINONIMOS = [
    [/hibrido enchufable/, ' plug in hybrid phev'],
    [/mild hybrid/, ' mhev'],
    [/hibrido/, ' hybrid hev'],
    [/electrico/, ' electric ev'],
    [/plazas/, ' seats'],
    [/puertas/, ' doors'],
  ];
  var CONSULTAR = {
    d: {
      texto: 'Antes de comprar tenemos que confirmar con fábrica la disponibilidad de este modelo. Escríbenos y te lo confirmamos.',
      pregunta: '¿Tenéis disponibilidad?',
    },
    p: {
      texto: 'Precio a consultar. Este modelo tiene un precio distinto al estándar: escríbenos y te lo confirmamos.',
      pregunta: '¿Qué precio tiene?',
    },
    k: {
      texto: 'Tenemos que confirmar qué piezas lleva este modelo antes de comprarlo. Escríbenos y te lo confirmamos.',
      pregunta: '¿Qué piezas incluye?',
    },
  };

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function cargarScript(src, sri) {
    return new Promise(function (ok, ko) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      if (sri) {
        s.integrity = sri;
        s.crossOrigin = 'anonymous';
      }
      s.onload = ok;
      s.onerror = ko;
      document.head.appendChild(s);
    });
  }

  class CrModelPicker extends HTMLElement {
    connectedCallback() {
      if (this._listo) return;
      this._listo = true;

      this.formId = this.dataset.form;
      this.sectionId = this.formId.replace('product-form-', '');
      this.modelo = null;
      this.manual = false;
      this.activo = -1;
      this.resultados = [];

      this.$ = function (sel) { return this.querySelector('[' + sel + ']'); }.bind(this);
      this.input = this.$('data-input');
      this.lista = this.$('data-lista');
      this.props = {};
      this.querySelectorAll('[data-prop]').forEach(function (el) { this.props[el.dataset.prop] = el; }, this);

      this.input.addEventListener('focus', this.cargar.bind(this));
      this.input.addEventListener('pointerdown', this.cargar.bind(this));
      this.input.addEventListener('input', this.alEscribir.bind(this));
      this.input.addEventListener('keydown', this.alTeclear.bind(this));
      this.input.addEventListener('blur', function () {
        setTimeout(this.cerrarLista.bind(this), 150);
      }.bind(this));
      this.lista.addEventListener('mousedown', function (e) { e.preventDefault(); });
      this.lista.addEventListener('click', function (e) {
        var li = e.target.closest('[data-i]');
        if (li) this.elegir(this.resultados[+li.dataset.i]);
      }.bind(this));
      this.$('data-cambiar').addEventListener('click', this.cambiar.bind(this));
      this.$('data-pregunta').addEventListener('change', function (e) {
        this.limpiarError();
        // Elegir una opción anula la medida escrita (si no, la medida seguía contando en el pedido)
        if (e.target && e.target.type === 'radio') this.$('data-pregunta-medida').value = '';
      }.bind(this));
      this.$('data-pregunta-medida').addEventListener('input', this.alEscribirMedida.bind(this));
      this.$('data-manual-input').addEventListener('input', this.limpiarError.bind(this));

      // Validación antes de que el <product-form> de Dawn envíe (fase de captura).
      this._onSubmit = this.alEnviar.bind(this);
      document.addEventListener('submit', this._onSubmit, true);

      // Al cambiar de variante Dawn inserta un <variant-selects> nuevo junto al viejo
      // (HTMLUpdateUtility.viewTransition): se observa el contenedor, no el nodo.
      var vs = document.getElementById('variant-selects-' + this.sectionId);
      if (vs && vs.parentNode) {
        new MutationObserver(this.pintarPacks.bind(this)).observe(vs.parentNode, { childList: true, subtree: true });
      }

      // Colores del enlace: se marcan ya (solo si existen en el selector) y se avisa al configurador.
      var params = new URLSearchParams(location.search);
      Object.keys(PARAM_COLOR).forEach(function (param) {
        var valor = params.get(param);
        if (!valor) return;
        var radio = radiosColor(PARAM_COLOR[param]).find(function (r) { return slugURL(r.dataset.color || r.value) === slugURL(valor); });
        if (!radio || radio.checked) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
      // Cualquier cambio de color o de respuesta se refleja en la URL
      document.addEventListener('change', function (e) {
        var n = e.target && e.target.name || '';
        if (n.indexOf('properties[Color ') === 0 || n.indexOf('cr-mp-q-') === 0) this.ponerURL();
      }.bind(this));
      var tMedida;
      this.$('data-pregunta-medida').addEventListener('input', function () {
        clearTimeout(tMedida);
        tMedida = setTimeout(this.ponerURL.bind(this), 400);
      }.bind(this));

      // Dawn reescribe la URL al cambiar de pack (?variant=) y quita ?modelo: se vuelve a poner.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(this.ponerURL.bind(this), 0); }.bind(this));
      }

      var pre = new URLSearchParams(location.search).get('modelo');
      // leída antes de elegir: elegir() reescribe la URL
      var respuestaEnlace = new URLSearchParams(location.search).get('respuesta');
      if (pre) {
        this.cargar().then(function () {
          var m = this.porId && this.porId[pre];
          if (m) {
            this.elegir(m);
            this.aplicarRespuesta(respuestaEnlace);
          } else {
            this.ponerURL(); // modelo inexistente en el enlace: se ignora y sale de la URL
          }
        }.bind(this));
      } else {
        var diferido = function () { this.cargar(); }.bind(this);
        setTimeout(function () {
          ('requestIdleCallback' in window) ? requestIdleCallback(diferido) : diferido();
        }, 2000);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this._onSubmit, true);
    }

    // ---- carga -------------------------------------------------------------
    cargar() {
      if (this._carga) return this._carga;
      var self = this;

      var json = fetch(this.dataset.src, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
      // Fuse es una mejora: si el CDN falla, se busca por coincidencia simple.
      var fuse = cargarScript(this.dataset.fuse, this.dataset.fuseSri).catch(function () {});
      var limite = new Promise(function (_, ko) {
        setTimeout(function () { ko(new Error('timeout')); }, TIMEOUT_CARGA);
      });

      this._carga = Promise.race([Promise.all([json, fuse]), limite])
        .then(function (res) { self.indexar(res[0]); })
        .catch(function () { self.modoManual(); });
      return this._carga;
    }

    indexar(data) {
      var porId = {};
      this.modelos = data.m.map(function (r) {
        var años = (r[3].match(/\d{4}/g) || []).map(Number);
        var m = {
          id: r[0], marca: r[1], modelo: r[2], años: r[3], ref: r[4],
          pack: r[5] >= 0 ? data.k[r[5]] : '',
          maletero: r[6] === 1,
          pregunta: r[7] >= 0 ? data.q[r[7]] : null,
          estado: r[8],
          desde: años[0] || 0,
          hasta: años.length > 1 ? años[años.length - 1] : (años[0] || 0),
        };
        m.n = norm(m.marca + ' ' + (ALIAS[m.marca.toLowerCase()] || '') + ' ' + m.modelo);
        SINONIMOS.forEach(function (s) { if (s[0].test(m.n)) m.n += s[1]; });
        porId[m.id] = m;
        return m;
      });
      this.porId = porId;
      if (window.Fuse) {
        this.fuse = new window.Fuse(this.modelos, {
          keys: ['n'],
          threshold: 0.38,
          ignoreLocation: true,
          useExtendedSearch: true,
        });
      }
      if (this.input.value && !this.modelo) this.buscar(this.input.value);
    }

    modoManual() {
      if (this.modelos) return;
      this.manual = true;
      this.$('data-buscar').hidden = true;
      this.$('data-manual').hidden = false;
    }

    // ---- búsqueda ----------------------------------------------------------
    alEscribir() {
      this.limpiarError();
      if (!this.modelos) {
        this.cargar();
        return;
      }
      this.buscar(this.input.value);
    }

    buscar(q) {
      var tokens = norm(q).split(' ').filter(Boolean);
      var año = 0;
      var texto = tokens.filter(function (t) {
        if (/^(19|20)\d\d$/.test(t)) { año = +t; return false; }
        return true;
      });

      if (!texto.length) {
        this.resultados = [];
        this.pintarLista(q);
        return;
      }

      var encontrados;
      if (this.fuse) {
        encontrados = this.fuse.search(texto.join(' '), { limit: 40 }).map(function (r) { return r.item; });
      } else {
        encontrados = this.modelos.filter(function (m) {
          return texto.every(function (t) { return m.n.indexOf(t) !== -1; });
        }).slice(0, 40);
      }

      // El año ordena, no filtra: si el catálogo tiene un año mal, el modelo sigue apareciendo.
      if (año) {
        encontrados = encontrados
          .map(function (m, i) { return { m: m, i: i, ok: m.desde <= año && año <= m.hasta }; })
          .sort(function (a, b) { return (b.ok - a.ok) || (a.i - b.i); })
          .map(function (x) { return x.m; });
      }

      this.resultados = encontrados.slice(0, MAX_RESULTADOS);
      this.pintarLista(q);
    }

    pintarLista(q) {
      var lista = this.lista;
      lista.textContent = '';
      this.activo = -1;
      this.resultados.forEach(function (m, i) {
        var li = document.createElement('li');
        li.id = lista.id + '-' + i;
        li.className = 'cr-mp-resultado';
        li.setAttribute('role', 'option');
        li.dataset.i = i;

        var nombre = document.createElement('span');
        nombre.className = 'cr-mp-r-nombre';
        nombre.textContent = m.marca + ' ' + m.modelo;

        var meta = document.createElement('span');
        meta.className = 'cr-mp-r-meta';
        meta.textContent = m.años || '';

        li.append(nombre, meta);
        if (m.estado) {
          var tag = document.createElement('span');
          tag.className = 'cr-mp-r-tag';
          tag.textContent = m.estado === 'p' ? 'Precio a consultar' : 'Consultar disponibilidad';
          li.append(tag);
        }
        lista.append(li);
      });

      var hayTexto = norm(q).replace(/\b(19|20)\d\d\b/g, '').trim().length > 0;
      var vacio = hayTexto && !this.resultados.length;
      lista.hidden = !this.resultados.length;
      this.input.setAttribute('aria-expanded', String(!lista.hidden));
      this.input.removeAttribute('aria-activedescendant');

      this.$('data-vacio').hidden = !vacio;
      if (vacio) {
        this.$('data-vacio-texto').textContent = q.trim();
        this.$('data-vacio-wa').href = this.urlWa(
          'Hola, no encuentro mi coche en la web: ' + q.trim() + '. ¿Tenéis alfombrillas para él?'
        );
      }
    }

    cerrarLista() {
      this.lista.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
    }

    alTeclear(e) {
      var n = this.resultados.length;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!n) return;
        e.preventDefault();
        this.lista.hidden = false;
        this.activo = (this.activo + (e.key === 'ArrowDown' ? 1 : -1) + n) % n;
        this.lista.querySelectorAll('[data-i]').forEach(function (li, i) {
          li.setAttribute('aria-selected', String(i === this.activo));
          if (i === this.activo) {
            this.input.setAttribute('aria-activedescendant', li.id);
            li.scrollIntoView({ block: 'nearest' });
          }
        }, this);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (n) this.elegir(this.resultados[this.activo >= 0 ? this.activo : 0]);
      } else if (e.key === 'Escape') {
        this.cerrarLista();
      }
    }

    // ---- selección ---------------------------------------------------------
    elegir(m) {
      this.modelo = m;
      this.cerrarLista();
      this.limpiarError();
      this.input.blur();

      this.$('data-buscar').hidden = true;
      this.$('data-vacio').hidden = true;
      this.$('data-chip').hidden = false;
      this.$('data-chip-nombre').textContent = m.marca + ' ' + m.modelo + (m.años ? ' · ' + m.años : '');

      this.prop('modelo', m.marca + ' ' + m.modelo + (m.años ? ' (' + m.años + ')' : ''));
      this.prop('id', m.id);
      this.prop('ref', m.ref);

      var consultar = CONSULTAR[m.estado];
      this.$('data-consultar').hidden = !consultar;
      if (consultar) {
        this.$('data-consultar-texto').textContent = consultar.texto;
        this.$('data-consultar-wa').href = this.urlWa(
          'Hola, quiero alfombrillas para mi ' + m.marca + ' ' + m.modelo + ' (' + m.años + '). ' + consultar.pregunta
        );
      }
      this.bloquearCompra(consultar ? this.$('data-consultar-wa').href : null);

      this.pintarPregunta(consultar ? null : m.pregunta);
      this.pintarPacks();
      this.ponerURL();
      this.dispatchEvent(new CustomEvent('cr:modelo', { bubbles: true, detail: { modelo: m } }));
    }

    cambiar() {
      this.modelo = null;
      ['modelo', 'id', 'ref', 'respuesta', 'pendiente', 'pregunta', 'maletero'].forEach(function (k) { this.prop(k, null); }, this);
      this.$('data-chip').hidden = true;
      this.$('data-consultar').hidden = true;
      this.$('data-buscar').hidden = false;
      this.pintarPregunta(null);
      this.bloquearCompra(null);
      this.pintarPacks();
      this.input.value = '';
      this.input.focus();
      this.ponerURL();
      this.dispatchEvent(new CustomEvent('cr:modelo', { bubbles: true, detail: { modelo: null } }));
    }

    // ?modelo={id} en la URL sin recargar: el enlace copiado abre la ficha con ese coche elegido.
    // Se conservan los demás parámetros (p. ej. ?variant= del pack) y el ancla.
    ponerURL() {
      try {
        var url = new URL(location.href);
        if (this.modelo && this.modelo.id) url.searchParams.set('modelo', this.modelo.id);
        else url.searchParams.delete('modelo');
        Object.keys(PARAM_COLOR).forEach(function (param) {
          var marcado = radiosColor(PARAM_COLOR[param]).find(function (r) { return r.checked; });
          if (marcado && !marcado.defaultChecked) url.searchParams.set(param, slugURL(marcado.dataset.color || marcado.value));
          else url.searchParams.delete(param);
        });
        var r = this.respuestaURL();
        if (r) url.searchParams.set('respuesta', r);
        else url.searchParams.delete('respuesta');
        // Con coche, el enlace abre directamente en el configurador (el cliente ve su selección)
        if (this.modelo && !url.hash) url.hash = 'cr-configurar';
        if (!this.modelo && url.hash === '#cr-configurar') url.hash = '';
        if (url.href !== location.href) history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      } catch (e) { /* sin URL o sin history: no pasa nada */ }
    }

    prop(k, v) {
      var el = this.props[k];
      el.value = v == null ? '' : v;
      el.disabled = v == null || v === '';
    }

    urlWa(texto) {
      return 'https://wa.me/' + this.dataset.wa + '?text=' + encodeURIComponent(texto);
    }

    // Modelos a consultar: se oculta el botón de compra y se ofrece WhatsApp en su lugar.
    bloquearCompra(urlWa) {
      var form = document.getElementById(this.formId);
      var pf = form && form.closest('product-form');
      if (!pf) return;
      pf.classList.toggle('cr-mp-bloqueado', !!urlWa);
      var cta = pf.querySelector('.cr-mp-wa-compra');
      if (urlWa && !cta) {
        cta = document.createElement('a');
        cta.className = 'cr-mp-wa cr-mp-wa-compra';
        cta.target = '_blank';
        cta.rel = 'noopener';
        cta.textContent = 'Consultar por WhatsApp';
        form.after(cta);
      }
      if (cta) {
        cta.hidden = !urlWa;
        if (urlWa) cta.href = urlWa;
      }
    }

    // ---- pregunta de verificación -----------------------------------------
    pintarPregunta(q) {
      var fs = this.$('data-pregunta');
      var cont = this.$('data-pregunta-opciones');
      var medida = this.$('data-pregunta-medida');
      cont.textContent = '';
      medida.value = '';
      fs.hidden = !q;
      this.pregunta = q;
      this.prop('pregunta', q ? (q.texto || q.aviso) : null);
      this.prop('respuesta', null);
      this.prop('pendiente', null);
      if (!q) return;

      this.$('data-pregunta-texto').textContent = q.texto || q.aviso;
      medida.hidden = !q.medida;
      // Nota tranquilizadora bajo las preguntas con opciones (no en los avisos, que ya lo explican)
      this.$('data-pregunta-nota').hidden = !!q.aviso;
      medida.placeholder = q.medida || '';

      var opciones = q.aviso ? [ENTENDIDO] : (q.opciones || []).concat(NO_SE);
      var name = 'cr-mp-q-' + this.sectionId;
      opciones.forEach(function (texto, i) {
        var label = document.createElement('label');
        label.className = 'cr-mp-opcion';
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = name;
        input.value = texto;
        input.id = name + '-' + i;
        var span = document.createElement('span');
        span.textContent = texto;
        label.append(input, span);
        cont.append(label);
      });
    }

    alEscribirMedida() {
      this.limpiarError();
      var marcado = this.$('data-pregunta-opciones').querySelector('input:checked');
      if (marcado && this.$('data-pregunta-medida').value) marcado.checked = false;
    }

    respuesta() {
      if (!this.pregunta) return '';
      var medida = this.$('data-pregunta-medida');
      if (this.pregunta.medida && medida.value.trim()) return medida.value.trim();
      var marcado = this.$('data-pregunta-opciones').querySelector('input:checked');
      if (!marcado) return '';
      return marcado.value === NO_SE || marcado.value === ENTENDIDO ? PENDIENTE : marcado.value;
    }

    // Respuesta en la URL: la opción (como slug), "foto" si no lo sabe, o la medida escrita
    respuestaURL() {
      if (!this.modelo || !this.pregunta) return '';
      var medida = this.$('data-pregunta-medida');
      if (this.pregunta.medida && medida.value.trim()) return medida.value.trim().slice(0, 80);
      var marcado = this.$('data-pregunta-opciones').querySelector('input:checked');
      if (!marcado) return '';
      return marcado.value === NO_SE || marcado.value === ENTENDIDO ? RESPUESTA_FOTO : slugURL(marcado.value);
    }

    // Respuesta del enlace: solo si corresponde a la pregunta de este modelo; si no, se ignora
    aplicarRespuesta(valor) {
      if (!valor || !this.pregunta) { this.ponerURL(); return; }
      var opciones = Array.prototype.slice.call(this.$('data-pregunta-opciones').querySelectorAll('input'));
      var elegida = opciones.find(function (o) {
        return valor === RESPUESTA_FOTO ? (o.value === NO_SE || o.value === ENTENDIDO) : slugURL(o.value) === slugURL(valor);
      });
      if (elegida) elegida.checked = true;
      else if (this.pregunta.medida && valor !== RESPUESTA_FOTO) this.$('data-pregunta-medida').value = String(valor).slice(0, 80);
      this.ponerURL();
    }

    // ---- packs según el modelo --------------------------------------------
    pintarPacks() {
      var cards = document.querySelectorAll('#variant-selects-' + this.sectionId + ' [data-cr-pack]');
      var m = this.modelo;
      var sinPlantilla = m && !m.maletero;
      // Sin plantilla de maletero: el pack se vende igual; solo una nota neutra bajo el pack.
      var aviso = 'Después de la compra te escribimos por WhatsApp para pedirte unas medidas del maletero.';

      cards.forEach(function (card) {
        var tipo = card.dataset.crPack;
        var desc = card.querySelector('.cr-pk-desc');
        if (desc) {
          if (!desc.dataset.original) desc.dataset.original = desc.textContent;
          var texto = desc.dataset.original;
          if (m && m.pack && tipo === 'interior') texto = m.pack;
          if (m && m.pack && tipo === 'juego') texto = m.pack + ' + maletero';
          // Delanteras: siempre «Conductor y copiloto», salvo si la delantera del modelo es de una pieza
          if (m && m.pack && tipo === 'delanteras' && /corrida|fila delantera/i.test(m.pack)) texto = 'Parte delantera';
          if (desc.textContent !== texto) desc.textContent = texto;
        }
        var nota = card.querySelector('[data-cr-pack-aviso]');
        if (nota) {
          var mostrar = !!sinPlantilla && (tipo === 'maletero' || tipo === 'juego');
          if (nota.hidden === mostrar) nota.hidden = !mostrar;
          if (mostrar && nota.textContent !== aviso) nota.textContent = aviso;
        }
      });
    }

    packLlevaMaletero() {
      var vs = document.getElementById('variant-selects-' + this.sectionId);
      var marcado = vs && vs.querySelector('input[type="radio"]:checked');
      var card = marcado && marcado.closest('[data-cr-pack]');
      return !!card && (card.dataset.crPack === 'maletero' || card.dataset.crPack === 'juego');
    }

    // ---- validación al añadir al carrito -----------------------------------
    alEnviar(e) {
      // getAttribute: el <input name="id"> de la variante tapa form.id
      if (!e.target || !e.target.getAttribute || e.target.getAttribute('id') !== this.formId) return;
      var error = this.validar();
      if (!error) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.mostrarError(error.texto, error.foco);
    }

    validar() {
      if (this.manual) {
        var escrito = this.$('data-manual-input').value.trim();
        if (!escrito) return { texto: 'Escribe tu coche para continuar.', foco: this.$('data-manual-input') };
        this.prop('modelo', escrito);
        this.prop('id', 'manual');
        return null;
      }
      if (!this.modelo) return { texto: 'Elige tu coche para continuar.', foco: this.input };
      if (this.modelo.estado) return { texto: 'Este modelo se consulta por WhatsApp antes de comprar.', foco: this.$('data-consultar-wa') };

      if (this.pregunta) {
        var r = this.respuesta();
        if (!r) {
          var primero = this.pregunta.medida ? this.$('data-pregunta-medida') : this.$('data-pregunta-opciones').querySelector('input');
          return { texto: 'Responde a la pregunta sobre tu coche para continuar.', foco: primero };
        }
        this.prop('respuesta', r);
        this.prop('pendiente', r === PENDIENTE ? PENDIENTE_ADMIN : null);
      }

      this.prop(
        'maletero',
        !this.modelo.maletero && this.packLlevaMaletero()
          ? 'sin plantilla, pedir medidas al cliente'
          : null
      );
      return null;
    }

    mostrarError(texto, foco) {
      var el = this.$('data-error');
      el.textContent = texto;
      el.hidden = false;
      this.classList.add('cr-mp--error');
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (foco) setTimeout(function () { foco.focus({ preventScroll: true }); }, 300);
    }

    limpiarError() {
      this.$('data-error').hidden = true;
      this.classList.remove('cr-mp--error');
    }
  }

  customElements.define('cr-model-picker', CrModelPicker);
})();
